import { Guid, Nillable } from '@web/utils';
import { AdminSubscriptionBillingAddress } from './admin-subscription-billing-address';
import { AdminSubscriptionShippingAddress } from './admin-subscription-shipping-address';
import {
  ShippingMethodDictionary,
  SubscriptionCancelReason,
  SubscriptionNumber,
  SubscriptionStatus,
  SubscriptionSuspendReason,
} from '@web/shared/module/shop';
import { AdminPaymentMethod } from './admin-payment-method';
import { AdminSubscriptionItem } from './admin-subscription-item';
import { AdminOwner } from './admin-owner';

export class AdminSubscriptionDetails {
  public constructor(
    private readonly data: {
      canBillingAddressBeUpdated: boolean;
      canShippingAddressBeUpdated: boolean;
      id: Guid;
      isLocked: boolean;
      number: SubscriptionNumber;
      status: SubscriptionStatus;
      totalPrice: number;
      itemsPrice: number;
      shippingPrice: number;
      lastPaymentDate: Date;
      nextPaymentDate?: Nillable<Date>;
      cardChargeDay: number;
      cancelledDate?: Nillable<Date>;
      suspendedDate?: Nillable<Date>;
      resumedDate?: Nillable<Date>;
      cardChargeDayChangedDate?: Nillable<Date>;
      owner?: Nillable<AdminOwner>;
      cancelReason?: Nillable<SubscriptionCancelReason>;
      suspendReason?: Nillable<SubscriptionSuspendReason>;
      billingAddress: AdminSubscriptionBillingAddress;
      shippingAddress: AdminSubscriptionShippingAddress;
      paymentMethod: AdminPaymentMethod;
      shippingMethod: ShippingMethodDictionary;
      items: AdminSubscriptionItem[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get isLocked(): boolean {
    return this.data.isLocked;
  }

  public get number(): SubscriptionNumber {
    return this.data.number;
  }

  public get status(): SubscriptionStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get itemsPrice(): number {
    return this.data.itemsPrice;
  }

  public get shippingPrice(): number {
    return this.data.shippingPrice;
  }

  public get billingAddress(): AdminSubscriptionBillingAddress {
    return this.data.billingAddress;
  }

  public get shippingAddress(): AdminSubscriptionShippingAddress {
    return this.data.shippingAddress;
  }

  public get lastPaymentDate(): Date {
    return this.data.lastPaymentDate;
  }

  public get nextPaymentDate(): Nillable<Date> {
    return this.data.nextPaymentDate;
  }

  public get cardChargeDay(): number {
    return this.data.cardChargeDay;
  }

  public get cancelledDate(): Nillable<Date> {
    return this.data.cancelledDate;
  }

  public get suspendedDate(): Nillable<Date> {
    return this.data.suspendedDate;
  }

  public get resumedDate(): Nillable<Date> {
    return this.data.resumedDate;
  }

  public get cardChargeDayChangedDate(): Nillable<Date> {
    return this.data.cardChargeDayChangedDate;
  }

  public get owner(): Nillable<AdminOwner> {
    return this.data.owner;
  }

  public get cancelReason(): Nillable<SubscriptionCancelReason> {
    return this.data.cancelReason;
  }

  public get suspendReason(): Nillable<SubscriptionSuspendReason> {
    return this.data.suspendReason;
  }

  public get paymentMethod(): AdminPaymentMethod {
    return this.data.paymentMethod;
  }

  public get shippingMethod(): ShippingMethodDictionary {
    return this.data.shippingMethod;
  }

  public get items(): AdminSubscriptionItem[] {
    return this.data.items;
  }

  public get canBillingAddressBeUpdated(): boolean {
    return this.data.canBillingAddressBeUpdated;
  }
  public get canShippingAddressBeUpdated(): boolean {
    return this.data.canShippingAddressBeUpdated;
  }
}
